import React, { useEffect } from 'react'
import Supplier from '../Editors/Supplier'
import { Route, useHistory, useLocation, useParams } from 'react-router-dom';
import SupplierAircraftList from '../EntityList/SupplierAircraftList';
import SupplierDocumentList from '../EntityList/SupplierDocumentList';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tabs'
import { useEdit } from '../../Services/EditContext';
import BidHistory from '../EntityList/BidHistory';
import SupplierInsuranceDocumentList from '../EntityList/SupplierInsuranceDocumentList';
import { useFormikContext } from 'formik';
import { SupplierMessageLog, ViewMessageLogModal } from '../EntityList/ViewMessageLog';
import TimeLine from '../EntityList/TimeLine';
import { useAuth } from '../../Services/AuthContext';

const EditSupplier = ({ route, isNewItem, charterRequestId }) => {
    const { activeKey, supplierId } = useParams();
    const location = useLocation();
    const queryCharterRequestId = new URLSearchParams(location.search).get('charterRequestId');
    const scopedCharterRequestId = charterRequestId || queryCharterRequestId;
    const { values } = useFormikContext();
    let { push } = useHistory();
    const {clientTypes}={...values};
    const setActiveTab = (tab) => {

        if (push && supplierId && route) {
            const tabRoute = route + '/' + supplierId + '/' + tab;
            push(scopedCharterRequestId ? tabRoute + '?charterRequestId=' + encodeURIComponent(scopedCharterRequestId) : tabRoute);
        }

    }
    useEffect(() => {
        if (push && !activeKey && supplierId && route) {
            const detailRoute = route + '/' + supplierId + '/Detail';
            push(scopedCharterRequestId ? detailRoute + '?charterRequestId=' + encodeURIComponent(scopedCharterRequestId) : detailRoute);
        }
    }, [activeKey, push, route, scopedCharterRequestId, supplierId])

    const [edit] = useEdit();
    const [auth] = useAuth();
    
    const isAdminOrSupplier=auth.role==='Admin'||auth.role==='Supplier';
    const qGov = clientTypes ? clientTypes.includes("QGov") : false;
      

    return <Tabs onSelect={setActiveTab} activeKey={activeKey} style={{ height: '100%' }}>
        <Tab key={'Detail'} eventKey={'Detail'} title='Detail' >
            <Supplier invite={isNewItem} route={`${route}`} />
        </Tab>
        {!edit && <Tab key={'Aircraft'} eventKey={'Aircraft'} title='Aircraft' >
            {activeKey === 'Aircraft' ? <SupplierAircraftList route={route + '/' + supplierId + '/' + activeKey} supplierId={supplierId} headerHeight={0} isQGov={qGov} /> : null}
        </Tab>
        }
        {!edit && <Tab key={'Documents'} eventKey={'Documents'} title='Operator Documents' >
            {activeKey === 'Documents' ? <SupplierDocumentList route={route + '/' + supplierId + '/' + activeKey} parentHeight={400} headerHeight={0} charterRequestId={scopedCharterRequestId} /> : null}
        </Tab>
        }
        {!edit && <Tab key={'InsuranceDocuments'} eventKey={'InsuranceDocuments'} title='Insurance Documents' >
            {activeKey === 'InsuranceDocuments' ? <SupplierInsuranceDocumentList route={route + '/' + supplierId + '/' + activeKey} parentHeight={400} headerHeight={0} charterRequestId={scopedCharterRequestId} /> : null}
        </Tab>
        }
        {!edit && isAdminOrSupplier && <Tab key={'Bids'} eventKey={'Bids'} title='Bids' >
            {activeKey === 'Bids' ? <BidHistory item={values} route={route + '/' + supplierId + '/' + activeKey} headerHeight={0} /> : null}
        </Tab>}
        {!edit && isAdminOrSupplier && <Tab key={'Messages'} eventKey={'Messages'} title='Messages' >
            {activeKey === 'Messages' ? <SupplierMessageLog supplierId={values?.id} item={values} route={route + '/' + supplierId + '/' + activeKey} headerHeight={0} /> : null}
            <Route path={route + '/' + supplierId + '/Messages/:messageId'} render={() => <ViewMessageLogModal />} />
        </Tab>
        }
        {!edit && isAdminOrSupplier && <Tab key={'Timeline'} eventKey={'Timeline'} title='Timeline' >
            {activeKey === 'Timeline' ? <TimeLine clientCol charterRequestCol type={"Supplier"} item={values} route={route + '/' + supplierId + "/Timeline"} headerHeight={0} /> : null}
        </Tab>
        }
        
    </Tabs >
}


export default EditSupplier;